const zIndexesStack = ['basic', 'tableHeader', 'header', 'notification'] as const;
type ZIndexItems = typeof zIndexesStack[number];

export const getZIndex = (item: ZIndexItems): number => zIndexesStack.indexOf(item);
